import { defineStore } from 'pinia'

/**
 * 요청 카운트 상태 관리 (Pinia)
 * - Vuex requestModule 대체용
 */
export const useRequestStore = defineStore('request', {
  state: () => ({
    /** @type {number} */
    clusterRequestCount: 0,
    /** @type {number} */
    admissionRequestCount: 0,
  }),
  actions: {
    /**
     * @param {number} payload
     */
    setClusterRequestCount(payload) {
      this.clusterRequestCount = payload
    },
    /**
     * @param {number} payload
     */
    setAdmissionRequestCount(payload) {
      this.admissionRequestCount = payload
    },
    removeRequestCount() {
      this.clusterRequestCount = 0
      this.admissionRequestCount = 0
    },
  },
})

export default useRequestStore
